import { Form } from "components/Form/base/Form";
import { FormInput } from "components/Form/next";
import { Placeholder } from "components/Form/next/FormWYSIWYG";
import { useApi } from "../../../hooks/useApi";
import Joi from "joi";
import { useState } from "react";
import { MessageFields } from "./MessageFields";

interface Props {
    clubSlug: string;
    addresses?: string[];
    placeholders?: Placeholder[];
    callback?: () => void;
}

export const messageValidationSchema = {
    addresses: Joi.array()
        .min(1)
        .items(Joi.string().email({ tlds: false }).label("Die Addresse"))
        .label("E-Mail Adressen"),
    addresses_cc: Joi.array()
        .items(Joi.string().allow("", null).email({ tlds: false }).label("Die Addresse"))
        .label("E-Mail Adressen"),
    addresses_bcc: Joi.array()
        .items(Joi.string().allow("", null).email({ tlds: false }).label("Die Addresse"))
        .label("E-Mail Adressen"),
    subject: Joi.string().required().label("Betreff"),
    message: Joi.string().required().label("Nachricht"),
    text_message: Joi.boolean().allow(null).label("Nachricht ohne Stylings senden"),
};

export const MessageComponent = ({ clubSlug, addresses, callback, placeholders }: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const api = useApi();

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `message-management/${clubSlug}`,
            method: "POST",
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: () => callback?.(),
        });
    };

    const schema = Joi.object(messageValidationSchema).unknown();

    return (
        <Form
            onSubmit={handleSubmit}
            defaultValues={{ addresses: addresses?.join(", ") }}
            setDefaultValuesOnRerender={false}
            validationSchema={schema}
        >
            <MessageFields placeholders={placeholders} />
            <FormInput.Submit isLoading={isLoading}>Absenden</FormInput.Submit>
        </Form>
    );
};
